var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveAction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33325 2.66671C3.15644 2.66671 2.98687 2.73695 2.86185 2.86197C2.73682 2.98699 2.66659 3.15656 2.66659 3.33337V12.6667C2.66659 12.8435 2.73682 13.0131 2.86185 13.1381C2.98687 13.2631 3.15644 13.3334 3.33325 13.3334H12.6666C12.8434 13.3334 13.013 13.2631 13.138 13.1381C13.263 13.0131 13.3333 12.8435 13.3333 12.6667V5.60952L10.3904 2.66671H3.33325ZM1.91904 1.91916C2.29411 1.54409 2.80282 1.33337 3.33325 1.33337H10.6666C10.8434 1.33337 11.013 1.40361 11.138 1.52864L14.4713 4.86197C14.5963 4.98699 14.6666 5.15656 14.6666 5.33337V12.6667C14.6666 13.1971 14.4559 13.7058 14.0808 14.0809C13.7057 14.456 13.197 14.6667 12.6666 14.6667H3.33325C2.80282 14.6667 2.29411 14.456 1.91904 14.0809C1.54397 13.7058 1.33325 13.1971 1.33325 12.6667V3.33337C1.33325 2.80294 1.54397 2.29423 1.91904 1.91916Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8.66667C4 8.29848 4.29848 8 4.66667 8H11.3333C11.7015 8 12 8.29848 12 8.66667V14C12 14.3682 11.7015 14.6667 11.3333 14.6667C10.9651 14.6667 10.6667 14.3682 10.6667 14V9.33333H5.33333V14C5.33333 14.3682 5.03486 14.6667 4.66667 14.6667C4.29848 14.6667 4 14.3682 4 14V8.66667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 1.33337C5.03486 1.33337 5.33333 1.63185 5.33333 2.00004V4.66671H10C10.3682 4.66671 10.6667 4.96518 10.6667 5.33337C10.6667 5.70156 10.3682 6.00004 10 6.00004H4.66667C4.29848 6.00004 4 5.70156 4 5.33337V2.00004C4 1.63185 4.29848 1.33337 4.66667 1.33337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveAction);
export default __webpack_public_path__ + "static/media/save-action.0ea7fd23f4b9d5bb134f950e53813624.svg";
export { ForwardRef as ReactComponent };